import React, { useState } from 'react'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import { Button, CardContent, CircularProgress } from '@mui/material'
import { TextInput, Form, required, useTranslate, useNotify } from 'react-admin'
import { useNavigate } from 'react-router'
import { userServices } from 'src/services/auth/user/user.service'

export const RecoverForm = (props: RecoverFormProps) => {
  const { className } = props
  const [loading, setLoading] = useState(false)
  const translate = useTranslate()
  const navigate = useNavigate()
  const notify = useNotify()

  const submit = async (values: FormData) => {
    try {
      setLoading(true)

      userServices.recoverPassword(values.username)
        .then(() => {
          setLoading(false)
          navigate('/login')
          notify('ra.auth.recover_password_success', { type: 'success' })
        })
        .catch((error: any) => {
          setLoading(false)
          notify('ra.auth.sign_in_error', { type: 'error' })
        })
    } catch (error) {}
  }

  return (
    <StyledForm onSubmit={submit as any} mode='onChange' noValidate className={className}>
      <CardContent className={RecoverFormClasses.content}>
        <TextInput
          autoFocus
          source='username'
          label={translate('ra.auth.username')}
          validate={required()}
          fullWidth
        />

        <Button
          variant='contained'
          type='submit'
          color='primary'
          disabled={loading}
          fullWidth
          className={RecoverFormClasses.recoverButton}
        >
          {loading ? (
            <CircularProgress className={RecoverFormClasses.icon} size={19} thickness={3} />
          ) : (
            translate('ra.auth.recover_password')
          )}
        </Button>

        <Button
          variant='contained'
          href='#/login'
          color='primary'
          disabled={loading}
          fullWidth
          className={RecoverFormClasses.button}
        >
          {translate('ra.auth.sign_in')}
        </Button>
      </CardContent>
    </StyledForm>
  )
}

const PREFIX = 'RaRecoverForm'

export const RecoverFormClasses = {
  content: `${PREFIX}-content`,
  button: `${PREFIX}-button`,
  recoverButton: `${PREFIX}-recover-button`,
  icon: `${PREFIX}-icon`,
}

const StyledForm = styled(Form, {
  name: PREFIX,
  overridesResolver: (props, styles) => styles.root,
})(({ theme }) => ({
  [`& .${RecoverFormClasses.content}`]: {
    width: 300,
  },
  [`& .${RecoverFormClasses.button}`]: {
    marginTop: theme.spacing(2),
  },
  [`& .${RecoverFormClasses.button}`]: {
    marginTop: theme.spacing(5),
  },
  [`& .${RecoverFormClasses.recoverButton}`]: {
    marginTop: theme.spacing(2),
  },
  [`& .${RecoverFormClasses.icon}`]: {
    margin: theme.spacing(0.3),
  },
}))

export interface RecoverFormProps {
  redirectTo?: string
  className?: string
}

interface FormData {
  username: string
  password: string
}

interface FormDataClient {
  username: string
  password: string
  user: number
}

RecoverForm.propTypes = {
  redirectTo: PropTypes.string,
}
